<div class="mb-2 message-text" [innerHTML]="data.message | async"></div>
<div class="mt-2 d-flex justify-content-end">
    <button type="button" mat-raised-button color="primary" class="me-2" (click)="yes()">
        {{ data.yesLabel | async }}
    </button>
    <button type="button" mat-raised-button color="primary" class="me-2" (click)="no()">
        {{ data.noLabel | async }}
    </button>
    <button color="accent" mat-raised-button (click)="cancel()">
        {{ data.cancelLabel | async }}
    </button>
</div>